module.exports = __webpack_public_path__ + "img/addcar.c39cda55.webp";